/** This export is automatically generated */
export const gitHash = '4cf1af5e7';
